import { MeshLoader, Mesh } from "./mesh-loader";
import { ShaderProgram } from "../webgl/webgl-program";
var RenderObject = (function () {
    function RenderObject(mesh_file_) {
        this.mesh_file_ = mesh_file_;
        this.mesh_loaded_ = false;
        this.transform_ = new Float32Array(16);
    }
    ;
    RenderObject.prototype.start = function (mesh_loader) {
        var _this = this;
        mesh_loader.loadMesh(this.mesh_file_).subscribe(function (mesh) {
            _this.mesh_ = mesh;
            _this.mesh_loaded_ = _this.mesh_.vertex_count > 0;
        });
    };
    ;
    RenderObject.prototype.draw = function (gl, program, array) {
        if (!this.mesh_loaded_)
            return;
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh_.vertex_buffer);
        gl.vertexAttribPointer(program.aVertexPosition, 3, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh_.normal_buffer);
        gl.vertexAttribPointer(program.aNormals, 3, gl.FLOAT, false, 0, 0);
        this.transform_.set(array);
        gl.uniformMatrix4fv(program.uTransform, false, this.transform_);
        gl.drawArrays(gl.TRIANGLES, 0, this.mesh_.vertex_count);
    };
    ;
    return RenderObject;
}());
export { RenderObject };
;
//# sourceMappingURL=render-object.js.map